import { http } from './http';

export interface ApiFolderLite {
  id: number;
  name: string;
  hasChildren?: boolean;
  Id?: number;
  Name?: string;
  HasChildren?: boolean;
}

function normalizeFolder(f: any): ApiFolderLite {
  return {
    ...f,
    id: Number(f?.id ?? f?.Id),
    name: String(f?.name ?? f?.Name ?? ''),
    hasChildren: Boolean(f?.hasChildren ?? f?.HasChildren)
  };
}

export async function getRootFolders(drawerId: number, filter?: string, skip = 0, take = 100): Promise<ApiFolderLite[]> {
  const url = `/api/folder/bydrawer?drawerid=${drawerId}`
    + (filter ? `&filter=${encodeURIComponent(filter)}` : '')
    + `&skip=${skip}&take=${take}`;
  const data = await http<any[]>(url);
  return Array.isArray(data) ? data.map(normalizeFolder) : [];
}

export async function getChildFolders(drawerId: number, folderId: number, filter?: string, skip = 0, take = 100): Promise<ApiFolderLite[]> {
  const url = `/api/folder/byparent?drawerid=${drawerId}&folderid=${folderId}`
    + (filter ? `&filter=${encodeURIComponent(filter)}` : '')
    + `&skip=${skip}&take=${take}`;
  const data = await http<any[]>(url);
  return Array.isArray(data) ? data.map(normalizeFolder) : [];
}

export interface FolderSearchResult<T = any> { items: T[]; continuationToken: string | null; }

export async function searchFolders<T = any>(drawerId: number, criteria: Record<string, { operator: string; value: string }>, orderBy?: string, take: number = 50, continuationToken?: string): Promise<FolderSearchResult<T>> {
  let filter = `drawer eq ${drawerId}`;
  Object.entries(criteria).forEach(([field, { operator, value }]) => {
    if (operator === 'empty' || operator === 'notempty') { filter += ` and ${field} ${operator}`; return; }
    if (operator === 'between') { filter += ` and ${field} ${operator} ${value ?? ''}`; return; }
    if (!value && operator === 'eq') return;
    filter += ` and ${field} ${operator} ${value}`;
  });
  const body: any = { filter, orderBy, take, continuationToken };
  const data = await http<any>('/api/folder/search', { method: 'POST', json: body });
  const items = (data as any).Values ?? data.values ?? (data as any).items ?? [];
  const token = (data as any).ContinuationToken ?? data.continuationToken ?? null;
  return { items, continuationToken: token };
}
